import { faBan, faCheck, faClock, faEdit, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React from 'react';
import { Button } from 'react-bootstrap';
import DataTable from '../../collection/DataTable';
import Boolean from '../../collection/icons/Boolean';
import TableHandler from '../../collection/TableHandler';
import ValidacionFilter from '../../components/filters/ValidacionFilter';
import HorasExtraModal from '../../components/modals/HorasExtraModal';
import HorasExtraResponsableModal from '../../components/modals/HorasExtraResponsableModal';
import FloatingAddButton from '../../components/project/FloatingAddButton';
import InfoHorasExtra from '../../components/project/InfoHorasExtra';
import { apiDelete, apiForm, apiGet, getSession } from '../../utils/api';
import { generateFormData, sortableString } from '../../utils/functions';

export default function HorasExtras(props) {
    // default filter
    const usuario = getSession();
    const defaultFilter = {
        desde: moment().startOf('year').format("YYYY-MM-DD"),
        hasta: null,
        trabajador: props.super ? null : usuario.id,
        pendiente: props.super ? true : null,
        validado: props.super ? null : true
    };
    let filter = generateFormData(defaultFilter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("horasextras/table", filter);
    }
    const deleteRow = async id => await apiDelete("horasextras/delete/" + id);
    const performAction = async (action, id) => await apiGet(`horasextras/${action}/${id}`);

    const actionDescriptor = (actionName, id) => <InfoHorasExtra id={id} action={actionName} />;

    // render
    return <>
        <h2>{`${props.super ? "Validar" : "Solicitar"} horas extra`}</h2>
        <TableHandler
            onUpdate={updateData}
            onDelete={deleteRow}
            onAction={performAction}
            actionDescriptor={actionDescriptor}
            elementText="las horas extra">
            <ValidacionFilter
                className="my-3" fem
                defaultValue={defaultFilter}
                selectFechas
                selectDepartamento={props.super && usuario.permisoAdmin}
                selectTrabajador={props.super}
                selectEstado />
            <HorasExtrasTable
                super={props.super} />
        </TableHandler>
    </>;
}

function HorasExtrasTable(props) {
    // table columns
    const columns = [
        {
            name: "Trabajador",
            selector: row => sortableString(row.NombreTrabajador),
            format: row => row.NombreTrabajador,
            sortable: true,
            omit: !props.super
        },
        {
            name: "Fecha",
            selector: row => moment(row.Fecha).format("YYYY-MM-DD"),
            format: row => moment(row.Fecha).format("DD/MM/YY"),
            sortable: true
        },
        {
            name: "Inicio",
            selector: row => row.StrHoraInicio,
            sortable: true
        },
        {
            name: "Final",
            selector: row => row.StrHoraFin,
            sortable: true
        },
        {
            name: "Horas",
            selector: row => row.Horas,
            sortable: true
        },
        {
            name: "Cliente",
            selector: row => sortableString(row.NombreCliente),
            format: row => <span title={row.NombreCliente}>{row.NombreCliente}</span>,
            sortable: true
        },
        {
            name: "Comentario",
            selector: row => sortableString(row.Comentario),
            format: row => row.Comentario,
            sortable: true
        },
        {
            name: "Comentario resp.",
            selector: row => sortableString(row.ComentarioResponsable),
            format: row => row.ComentarioResponsable,
            sortable: true
        },
        {
            name: "Validación",
            selector: row => row.Pendiente ? 0 : row.Validado ? 1 : 2,
            format: row => row.Pendiente ?
                <FontAwesomeIcon icon={faClock} className="text-secondary" title="Pendiente" size="lg" /> :
                <Boolean value={row.Validado} trueTitle="Aprobado" falseTitle="Denegado" size="lg" />,
            sortable: true,
            center: true
        }
    ];
    // table buttons
    const buttons = row => {
        return <>{
            props.super ?
                (row.Pendiente ?
                    <>
                        {/* super && pendiente */}
                        <Button title="Editar" variant="info" size="sm" onClick={props.onEdit}><FontAwesomeIcon icon={faEdit} /></Button>
                        <Button title="Aprobar" action="validate" variant="success" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faCheck} /></Button>
                        <Button title="Denegar" action="invalidate" variant="danger" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faTimes} /></Button>
                    </> :
                    (row.Validado ? <>
                        {/* super && !pendiente && validado */}
                        <Button title="Cancelar" action="cancel" variant="outline-danger" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faBan} /></Button>
                    </> : "")
                ) :
                (row.Pendiente ?
                    <>
                        {/* !super && pendiente */}
                        <Button variant="secondary" size="sm" onClick={props.onEdit}><FontAwesomeIcon icon={faEdit} /></Button>
                        <Button variant="danger" size="sm" onClick={props.onDelete}><FontAwesomeIcon icon={faTrash} /></Button>
                    </> : ""
                )
        }</>;
    };
    const name = row => `${row.NombreTrabajador}, ${moment(row.Fecha).format("DD/MM/YY")} (${row.StrHoraInicio}-${row.StrHoraFin})`;

    // render
    return <>
        <DataTable responsive rowname={name} buttons={buttons} columns={columns} data={props.data} pagination />
        {props.formOpen &&
            (props.super ?
                <HorasExtraResponsableModal
                    show={props.formOpen}
                    onHide={props.onFormClose}
                    idHorasExtra={props.formId} /> :
                <HorasExtraModal
                    show={props.formOpen}
                    onHide={props.onFormClose}
                    idHorasExtra={props.formId}
                />
            )
        }
        {!props.super && <FloatingAddButton onClick={props.onNew} />}
    </>;
}
